// Sendgrid created template list

export const sendgridTemplateList = [
  { id: "d-709579d803c04755af53417c3a80abd3", name: "Welcome User" },
  { id: "d-c8500c3f6ddc4795846efe89e2881eac", name: "Registered User" },
];



// WEBPACK FOOTER //
// ./app/components/helpers.js